import * as Yup from "yup";
const onlyDigitRegex = RegExp(/^[6789]\d{9}$/);

const loginValidationSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    // .max(10,"Cannot be more than 10 characeter")
    .matches(onlyDigitRegex, 'Phone number is not valid')
    .required("Phone number is required"),
  otp: Yup.string()
    .test("len", "OTP is too short", (val) => {
      if (!val) {
        return false;
      }
      return val.toString().length >= 5;
    })
    .required(),

});

export default loginValidationSchema;

export const emailValidationScehema = Yup.object().shape({
  email: Yup.string().email()
})
